import classnames from 'classnames';
import React, { FC } from 'react';
import { ILassoContext } from '../Lasso.types';
import styles from './LassoItem.scss';
import { IInner, IOuter } from './LassoItem.types';

export const LassoItemComponent: FC<IOuter & IInner & ILassoContext> = ({ className, saveRef, children, itemId }) => (
  <div ref={saveRef} className={classnames(styles.item, className)} data-hook="lasso-item" data-lasso-item-id={itemId}>
    {children}
  </div>
);
